import { ecllipse, greyLock } from "../images";

export const data = [
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
  {
    ecllipse: ecllipse,
    lock: greyLock,
    text: "ALWAYS SECURE",
  },
];
